var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasMore)?_c('div',[_c('ladda',{staticClass:"btn btn-primary btn-block",attrs:{"disabled":!_vm.hasMore,"loading":_vm.isLoading,"data-style":"zoom-out"},on:{"click":_vm.more}},[_vm._v("Load more")])],1):(!_vm.hideTotal)?_c('div',[_vm._v("Total: "+_vm._s(_vm.total))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }